import $ from 'jquery';
import _ from 'underscore';
import URI from 'urijs';

import Settings from 'source/lib/settings_model';

import BaseView from 'source/lib/base_view';
import template from 'authentication/templates/parts/footer.html';

const OPEN_FOOTER_CLASS = 'page__footer-open';
const CONTEXT = Symbol('context');

const FooterView = BaseView.extend({
    template,
    initialize() {
        const query = URI.parseQuery(window.location.search);
        if (this.$el.length === 0 || query.display === 'popup') {
            return;
        }
        this.delegateEvents({
            'click .js-region-change-selector': 'toogleRegionsList'
        });
        this.$body = $('body');
        $('.js-footer').removeClass('hidden');
        this.render();
    },
    toogleRegionsList() {
        const newState = !this.$body.hasClass(OPEN_FOOTER_CLASS);
        const body = this.$body[0];

        if (newState) {
            body.classList.add(OPEN_FOOTER_CLASS);
        } else {
            body.classList.remove(OPEN_FOOTER_CLASS);
        }
        const top = this.$el.position().top;
        const height = this.$el.outerHeight() + top;

        if (newState) {
            const $scroll = $('html, body');
            $scroll.animate({
                scrollTop: `${height}px`
            }, 300, () => {
                $scroll.scrollTop(height);
            });
        }
        return false;
    },
    render() {
        BaseView.prototype.render.call(this, this.context());
    },
    context() {
        if (this[CONTEXT]) {
            return this[CONTEXT];
        }
        const currentLanguageCode = Settings.get('General.LanguageCode');
        const currentRealm = Settings.get('Realm.CurrentRealm');

        const geowidgetsChangeWidgetItems = Settings.get('Request.GeowidgetsChangeWidgetItems', []);
        const realmData = geowidgetsChangeWidgetItems.map(([
            realm, url, regionName, langs
        ]) => {
            const isCurrentRealm = currentRealm === realm;
            const languageData = langs.map(([
                languageCode, languageName, languageUrl
            ]) => {
                const isCurrentLang = isCurrentRealm && currentLanguageCode === languageCode;
                return {
                    languageCode,
                    languageName,
                    languageUrl,
                    isCurrentLang
                };
            });
            return {
                realm,
                url,
                regionName,
                isCurrentRealm,
                languageData
            };
        });
        const context = {
            isKrSgRealm: _.contains(['sg', 'cn'], currentRealm),
            featureRealmCn: Settings.get('Realm.FeatureRealm') === 'cn',
            legalAge: currentRealm === 'ru' ? '12+&nbsp;' : '',
            realmData
        };
        const currentRegion = _.find(context.realmData, (realm) => realm.isCurrentRealm);
        if (currentRegion) {
            const currentLang = _.find(currentRegion.languageData, (lang) => lang.isCurrentLang);
            context.current = {
                region: currentRegion,
                lang: currentLang
            };
        }
        this[CONTEXT] = context;
        return context;
    }
});

export default FooterView;



// WEBPACK FOOTER //
// ./authentication/static-source/js/authentication/parts/footer.js